<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md10>
        <v-layout wrap>
          <v-flex xs12 sm12 md4 py-2>
            <v-img src="./../../assets/images/a6.jpg" height="200px" cover class="white--text">
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-4 pl-5 text-left>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm12 md4 py-2>
            <v-img src="./../../assets/images/a7.jpg" height="200px" cover class="white--text">
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-4 pl-5 text-left>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm12 md4 py-2>
            <v-img src="./../../assets/images/a8.jpg" height="200px" cover class="white--text">
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-4 pl-5 text-left>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["adds"],
  data() {
    return {
      advertisements: 0,
    };
  },
};
</script>